import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CategoryContext } from "./Context/ProductCategoryContext";
import { Box, Loader2, ArrowRight, Scan } from "lucide-react";
import { http } from "../../axios/axios";
import ProductCard from "../ProductCard";

const API_BASE =
  import.meta.env.VITE_API_BASE || "https://api.suraksha24x7.com";

export default function Productcardimages({ product }) {
  return (
    <div className="w-full">
      {product.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {product.map((item) => (
            <ProductCard key={item._id} item={item} />
          ))}
        </div>
      ) : (
        <div
          className="
  py-20
  text-center
  border
  border-dashed
  border-slate-300
  rounded-2xl
  bg-slate-50
"
        >
          <Box size={40} className="mx-auto text-slate-300 mb-4" />

          <h3 className="text-lg font-semibold text-slate-700 mb-2">
            No Products Available
          </h3>

          <p className="text-sm text-slate-500">
            We are currently updating our product collection. Please check back
            soon.
          </p>
        </div>
      )}
    </div>
  );
}
